import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Autoplay } from "swiper";
import "swiper/swiper-bundle.min.css";
import "swiper/swiper.min.css";

import dataSlider from "./Galery.Data";

import { Wrapper } from "./Galery.Styles";

const GalerySlider = () => {
	SwiperCore.use([Autoplay]);
	return (
		<Wrapper id="discover">
			<Swiper
				breakpoints={{
					320: {
						spaceBetween: 75,
					},
					375: {
						spaceBetween: 25,
					},
				}}
				lazy={true}
				slidesPerView="auto"
				grabCursor={true}
				mousewheel={true}
				loop={true}
			>
				{dataSlider.map(object => {
					return (
						<SwiperSlide key={object.alt} className="autoslide">
							<img
								src={object.img.default}
								alt={object.alt}
								key={object.alt}
							/>
						</SwiperSlide>
					);
				})}
			</Swiper>
		</Wrapper>
	);
};

export default GalerySlider;
